export default "__VITE_ASSET__DDKIlhnE__"